import React from 'react'
import * as ReactDOM from 'react-dom'
import { App } from './components/App'
import { GlobalStore } from './GlobalStore'
import { StoreProvider } from './stores'
import { DndProvider as DndProviderComp } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import 'antd/dist/reset.css'
import 'react-toastify/dist/ReactToastify.css'
// import 'semantic-ui-less/semantic.less'
const DndProvider: any = DndProviderComp

if (import.meta.env.DEV) {
  import('@locator/runtime').then(({ default: setupLocatorUI }) => setupLocatorUI())
}

declare global {
  interface Window {
    Hls: any
    io: any
  }
}

const apiUrl = import.meta.env.VITE_API_URL
const filesUrl = import.meta.env.VITE_FILES_URL
const socketUrl = import.meta.env.VITE_SOCKET_URL
const socketPath = import.meta.env.VITE_SOCKET_PATH

// console.log({ reactUrl: process.env })

export { apiUrl, filesUrl, socketUrl, socketPath }

const rootEl = document.getElementById('root')
ReactDOM.render(
  <StoreProvider>
    <GlobalStore>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
    </GlobalStore>
  </StoreProvider>,
  rootEl
)
